var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"sidenav-item"},[_c('router-link',{attrs:{"to":_vm.url}},[_c('span',{staticClass:"sidenav-item__icon"},[_vm._t("icon")],2),_c('span',{staticClass:"sidenav-item__title",class:{ 'sidenav-item__title-collapse': _vm.isSideNavCollapsed }},[_vm._v(_vm._s(_vm.title))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }